module.exports = __webpack_public_path__ + "img/tsk.109ec4d6.jpg";